import { useMemo } from 'react';
import {
  isSuggestion as isLabelASuggestion,
  useIsSmartSuggestionSettingEnabled
} from '../../timesheet-labels/hooks';
import {
  CustomLabel,
  TimesheetLabel
} from '../../timesheet-labels/labelSchema';

// TIDP-1774: Remove this hook when isEmptyLabelsEnabled is fully rolled out.
export const useIsSuggestion = (
  label: TimesheetLabel | CustomLabel | null | undefined
): boolean => {
  const isSmartSuggestionEnabled = useIsSmartSuggestionSettingEnabled();

  return useMemo(() => {
    if (!label) return false;
    return isLabelASuggestion(isSmartSuggestionEnabled, label);
  }, [isSmartSuggestionEnabled, label]);
};
